import { render } from 'preact';
import { FlashCard, FlashCardArea } from './components/FlashCards';
import { ReviewResult } from './lib/flash-card-utils';

const cardContainer = document.getElementById('test-card-el');
if (cardContainer) {
   render(<FlashCard
      card={{
         id: "/id/foo/bar",
         prompt: "What are the two Sigmoid equations?",
         answer: String.raw`$\frac{1}{1 + e^{-x}}$ and $\frac{e^x}{1 + e^x}$`,
         reviews: [{ result: 'again', date: new Date() }, { result: 'good', date: new Date() }],
      }}
      due={new Date()}
      onReview={(result: ReviewResult) => { }}
      onSkip={() => { }}
      doFinishedAck={() => { }}
      defaultConfig={{ collapsed: false }}
      onToggleOptions={() => { }}
      metadata={{ nReady: 1, nFiltered: 1, index: 0, prefix: "/", mode: 'review' }}
   />, cardContainer);
}

const areaContainer = document.getElementById('test-area-el');
if (areaContainer) {
   render(<FlashCardArea prefix="/ml" />, areaContainer);
}

const areaContainer2 = document.getElementById('test-area-el-2');
if (areaContainer2) {
   render(<FlashCardArea prefix="/" />, areaContainer2);
}
